import styled from "styled-components";

const FormContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.95);
  margin: 0 auto;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 500px;
  width: 100%;
  overflow-y: auto;
  max-height: calc(100vh - 40px);

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 152, 219, 0.5) transparent;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 152, 219, 0.5);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export default FormContainer;
